module.exports = __webpack_public_path__ + "assets/img/bind-phone.1788b7fe.png";